import { AuthorizationProvider } from '@frontend/authorization';
import { Logger } from '@frontend/logger';
import { ModalProvider } from '@frontend/modal';
import { AccountStoreProvider, BlobStoreProvider, BrandingStoreProvider, DocumentStoreProvider } from '@frontend/repository';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';

import { VERSION } from '../version';
import { KioskNetworkErrorBanner } from './components/kiosk-network-error-banner';
import { GeneralInfoRoutes } from './general-info/general-info-routes';
import Home from './home/home.component';
import Initialisation from './initialisation/initialisation.component';
import KeepAlive from './keep-alive/keep-alive.component';
import { KioskIdleTimerOverrideProvider } from './kiosk-idle-timer/kiosk-idle-timer-override.context';
import KioskIdleTimer from './kiosk-idle-timer/kiosk-idle-timer.component';
import { KioskRoutes } from './kiosk-routes';
import { useAppDispatch, useAppSelector } from './redux/store';
import TokenExpirationGuard from './token-expiration-guard/token-expiration-guard.component';
import { LicenseStoreProvider } from './utils/license-repository';
import Resolver from './utils/resolver';
import { WizardRoutes } from './wizard/wizard-routes';

export function App() {
    Logger.log(VERSION);
    const navigationState = useAppSelector((state) => state.navigation);
    const dispatch = useAppDispatch();
    const infoRoutes = GeneralInfoRoutes();
    const wizardRoutes = WizardRoutes();
    const kioskRoutes = KioskRoutes();

    return (
        <DocumentStoreProvider>
            <BlobStoreProvider>
                <BrandingStoreProvider>
                    <Router>
                        <AuthorizationProvider
                            dispatch={dispatch}
                            token={navigationState.user?.auth || undefined}>
                            <Initialisation>
                                <AccountStoreProvider>
                                    <LicenseStoreProvider>
                                        <ModalProvider>
                                            <Resolver>
                                                <KioskIdleTimerOverrideProvider>
                                                    <div
                                                        id='app-content'
                                                        className="h-dvh w-dvw overflow-hidden font-['Montserrat']">
                                                        <KioskNetworkErrorBanner />
                                                        <KeepAlive />
                                                        <KioskIdleTimer />
                                                        <TokenExpirationGuard />
                                                        <Routes>
                                                            {infoRoutes}
                                                            {wizardRoutes}
                                                            {kioskRoutes}
                                                            <Route
                                                                index
                                                                element={<Home />}
                                                            />
                                                            <Route
                                                                path='/*'
                                                                element={<Navigate to='/' />}
                                                            />
                                                        </Routes>
                                                    </div>
                                                </KioskIdleTimerOverrideProvider>
                                            </Resolver>
                                        </ModalProvider>
                                    </LicenseStoreProvider>
                                </AccountStoreProvider>
                            </Initialisation>
                        </AuthorizationProvider>
                    </Router>

                    <ToastContainer
                        position='top-center'
                        hideProgressBar
                        stacked={true}
                        draggable
                        autoClose={4000}
                        transition={Slide}
                    />
                </BrandingStoreProvider>
            </BlobStoreProvider>
        </DocumentStoreProvider>
    );
}

export default App;
